import React, { useState } from 'react';
import { Handle, Position } from 'reactflow';
import { usePipeline } from '../PipelineContext';

const NOTE_BORDER = {
  '#fef9c3': '#eab308',
  '#dbeafe': '#3b82f6',
  '#dcfce7': '#22c55e',
  '#fce7f3': '#ec4899',
  '#ede9fe': '#8b5cf6',
  '#ffedd5': '#f97316',
};

const NOTE_INFO = {
  what: 'A freeform sticky note on the canvas. Use it to leave context, document decisions, or flag something for review.',
  examples: ['Reminder — update SLA terms before Q3 review', 'Note — this gate triggers on weekdays only'],
};

export default function NoteNode({ data, selected }) {
  const [showInfo, setShowInfo] = useState(false);
  const { opsMode } = usePipeline() || {};
  const bg     = data.color || '#fef9c3';
  const border = NOTE_BORDER[bg] || '#d1a000';

  return (
    <div
      className={`note-node ${selected ? 'selected' : ''}`}
      style={{ background: bg, borderColor: border + '66' }}
    >
      <Handle type="target" position={Position.Left}  className="note-handle" />
      <Handle type="source" position={Position.Right} className="note-handle" />

      <div className="note-fold" style={{ borderRightColor: border + '55' }} />

      <button
        className="note-info-btn"
        style={{ color: border }}
        onMouseDown={e => e.stopPropagation()}
        onClick={e => { e.stopPropagation(); setShowInfo(s => !s); }}
      >ⓘ</button>
      {data.pinned && (
        <span className="note-pin-badge" style={{ color: border }} title="Pinned">📌</span>
      )}

      {data.title && (
        <div className="note-title">{data.title}</div>
      )}

      {data.body && (
        <div className="note-body">{data.body}</div>
      )}

      {showInfo && (
        <div className="node-info-card" style={{ background: bg, borderColor: border + '44' }}>
          <div className="node-info-what">{opsMode ? 'A freeform memo on the canvas. Use it to leave instructions, flag decisions, or add reminders for your team.' : NOTE_INFO.what}</div>
          <div className="node-info-eg-label">Examples:</div>
          {NOTE_INFO.examples.map((ex, i) => <div key={i} className="node-info-eg">→ {ex}</div>)}
        </div>
      )}

      {data.assignedLabels && data.assignedLabels.length > 0 && (
        <div className="note-tags">
          {data.assignedLabels.map((label, i) => (
            <span key={i} className="note-tag" style={{ background: border + '22', color: border }}>
              {label}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
